<template>
  <el-form-item
    label="訪客／廠商名稱"
    :required="isRequired"
  >
    <el-input
      v-model="guestName"
      :class="invalidClass"
      maxlength="20"
      placeholder="請輸入"
      :clearable="true"
      :disabled="disableGuestName"
      @input="handleChange"
    />

    <el-select
      v-model="guestVendor"
      :class="invalidClass"
      class="vendor-select"
      no-data-text="無廠商"
      :disabled="disableGuestVendor"
      style="margin-top: 12px;"
      @change="handleChange"
    >
      <el-option
        v-for="item in newVendorOptions"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      />
    </el-select>
  </el-form-item>
</template>
<script>
export default {
  props: {
    guestNameVal: {
      type: String,
      default: ''
    },
    guestVendorVal: {
      type: String,
      default: '請選擇'
    },
    isRequired: {
      type: Boolean,
      default: false
    },
    clear: {
      type: Boolean,
      default: false
    },
    cause: { // 目前選擇的訪客事由
      type: Number,
      default: 0
    },
    guestCauseList: { // 訪客事由清單
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      guestName: this.guestNameVal,
      guestVendor: !this.guestVendorVal ? '請選擇' : this.guestVendorVal,
      baseVendorOptions: [{ value: '請選擇', label: '請選擇' }],
      isValid: true
    }
  },
  computed: {
    invalidClass () {
      return !this.isValid ? 'invalid__border' : ''
    },
    disableGuestName () {
      return (this.guestVendor !== '請選擇') && (this.guestVendor !== '')
    },
    disableGuestVendor () {
      return this.guestName !== ''
    },
    newVendorOptions () {
      // 取出相關聯 訪客/廠商
      const vendorOptions = [...this.baseVendorOptions]
      const index = this.cause

      this.guestCauseList.forEach(item => {
        if (item.Id === index && item.VendorTypes.length !== 0) {
          item.VendorTypes.forEach(vendor => {
            vendorOptions.push({
              value: vendor.Name,
              label: vendor.Name
            })
          })
        }
      })

      return vendorOptions
    }
  },
  watch: {
    cause () {
      this.guestVendor = this.guestVendorVal
    },
    clear () {
      // 外部連動清空
      this.isValid = true
      this.guestName = this.guestNameVal
      this.guestVendor = this.guestVendorVal
    }
  },
  methods: {
    checkValid () {
      const isGuestNameEmpty = this.guestName === '' || !this.guestName
      const isGuestVendorUnSelect = this.guestVendor === '請選擇' || !this.guestVendor

      this.isValid = !(isGuestNameEmpty && isGuestVendorUnSelect)
    },
    handleChange () {
      this.checkValid()
      this.$emit('onChange', {
        guestName: this.guestName,
        guestVendor: this.guestVendor
      })
    }
  }
}
</script>

<style lang="sass" scoped>
.invalid__border
  ::v-deep .el-input__inner
      border: $dangerColorHover 1px solid

.vendor-select
  width: 100%
</style>
